import { withBreakpoints } from '@g4/boneyard/lib/Media';

import SiteLayout from '../../components/SiteLayout';
import HotelSearchFormLandingPage from '../../components/HotelSearchFormLandingPage';
import searchFormTranslations from '../../components/HotelSearchForm/searchFormTranslations';
import PreFetch from '../../components/PreFetch';
import { withTranslations } from '../../components/TranslationsContext';

const Index = () => (
  <SiteLayout title={'Hotel search form page'} hero={true}>
    <PreFetch page="/hotel-booking/hotels" />
    <HotelSearchFormLandingPage />
  </SiteLayout>
);

export default withBreakpoints(withTranslations(searchFormTranslations, Index));
